import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-legends-component',
  templateUrl: './legends-component.component.html',
  styleUrls: ['./legends-component.component.scss']
})
export class LegendsComponentComponent implements OnInit {

  legendsTable = LEGENDS_DATA
  displayedColumnLegends: string[] = [
    "no",
    "icon",
    "meaning",
  ];


  constructor() { }

  ngOnInit(): void {
  }

}


export interface LegendsElement {
  no: number;
  icons: string[];
  meaning: string;
}

const LEGENDS_DATA: LegendsElement[] = [
  {no: null, icons: ['minimize icon', 'minimize icon'],  meaning: 'lorem ipsum lorem ipsum'},
  // {no: null, icons: ['minimize', 'minimize'],  meaning: 'lorem ipsum lorem ipsums'},
];